import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-commande-statut-help',
  templateUrl: './commande-statut-help.component.html',
  styleUrls: ['./commande-statut-help.component.scss']
})
export class CommandeStatutHelpComponent {
  constructor(
    private dialogRef: MatDialogRef<CommandeStatutHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  refuse() {
    this.dialogRef.close(false);
  }
}